import { Container } from './styles/Container.style';

export default function Portfolio() {
	return (
		<>
			<Container>
				<h1>Portfolio</h1>
			</Container>
		</>
	);
}
